import { Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GalaxyFilterDefinitionInterface,
  GalaxyFilterChipDependencies,
  GalaxyFilterInterface,
} from '@vendasta/galaxy/filter/chips';

// Injection token for ActivityFilterDefinitionsService
export const ACTIVITY_FILTER_DEFINITIONS_SERVICE_TOKEN = new InjectionToken<ActivityFilterDefinitionsService>(
  'ActivityFilterDefinitionsService',
);

/**
 * Abstract base class for activity filter definitions.
 * Applications should extend this to provide their own filter logic.
 */
@Injectable()
export abstract class ActivityFilterDefinitionsService implements GalaxyFilterChipDependencies {
  /**
   * Indicates whether this service provides any filters.
   * Applications should set this to true if they have filters, false otherwise.
   */
  abstract readonly hasFilters: boolean;

  /**
   * Abstract method to provide filter definitions.
   * Applications should implement this with their specific filters.
   */
  abstract listObjectFilters(searchTerm: string): Observable<GalaxyFilterDefinitionInterface[]>;

  /**
   * Abstract method to provide field options for a given field.
   * Applications should implement this with their specific data sources.
   */
  abstract getFieldOptions(fieldId: string, search: string): Observable<string[]>;

  /**
   * Abstract method to process filters and return application-specific filter criteria.
   * This allows applications to transform galaxy filters into their domain-specific format.
   * For example, partner-center might convert sales team filters to user IDs.
   */
  abstract processFilters(filters: GalaxyFilterInterface[]): Observable<any>;

  /**
   * Default implementation - applications can override if needed.
   */
  async getInitialAppliedFilters(): Promise<any[]> {
    return [];
  }

  /**
   * Default implementation - applications can override if needed.
   */
  setInitialAppliedFilters(_filters: any[]): void {
    // No-op for now
  }
}
